import { find, get } from 'lodash';
import { getDiffConfigForStudent } from 'utils/methods/math';

const AI_GRADING_LEVEL_MAP = {
    NoviceLow: 'Novice low',
    NoviceMid: 'Novice mid',
    NoviceHigh: 'Novice high',
    IntermediateLow: 'Intermediate low',
    IntermediateMid: 'Intermediate mid',
    IntermediateHigh: 'Intermediate high',
    AdvanceLow: 'Advance low',
    AdvanceMid: 'Advance mid',
    AdvanceHigh: 'Advance high',
};

const isUuid = (value) =>
    typeof value === 'string' &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);

export const resolveAiGradingLevel = ({
    submission,
    activityAssignment,
    combinedAssignments = [],
    selectedStudentId,
    currentClassId,
    currentSubmissionNo,
}) => {
    if (!submission) {
        return '';
    }

    const latestSubmissionIndex = Math.max((submission?.submissions || 1) - 1, 0);
    const submissionNo = currentSubmissionNo ?? latestSubmissionIndex;
    const isCurrentSubmissionView =
        currentSubmissionNo == null || submissionNo === latestSubmissionIndex;

    let aiGradeLevel = null;
    let configGradeLevel = null;

    if (submission?.ai_grade && Array.isArray(submission.ai_grade) && submission.ai_grade.length > 0) {
        const firstAiGrade = submission.ai_grade[0];
        if (firstAiGrade?.grade_level) {
            aiGradeLevel = firstAiGrade.grade_level;
        }
    }

    const submissionAiConfig = submission?.ai_grading_config || {};
    const submissionConfigGradeLevel =
        submissionAiConfig?.creteria?.grade_level ||
        submissionAiConfig?.criteria?.grade_level ||
        submissionAiConfig?.grade_level ||
        null;

    if (submissionConfigGradeLevel) {
        configGradeLevel = submissionConfigGradeLevel;
    }

    const assignmentId =
        submission?.assignmentId ||
        activityAssignment?.quizId ||
        activityAssignment?.activityId ||
        activityAssignment?.seesion_id;

    const class_act =
        find(
            combinedAssignments,
            (v) =>
                v?.quizId === assignmentId ||
                v?.activityId === assignmentId ||
                v?.seesion_id === assignmentId ||
                v?.data?.id === assignmentId
        ) ||
        activityAssignment ||
        {};

    if (
        !configGradeLevel &&
        (!submission?.complete || isCurrentSubmissionView) &&
        selectedStudentId &&
        (class_act.classId || currentClassId)
    ) {
        const groupConfig = getDiffConfigForStudent(
            selectedStudentId,
            class_act,
            class_act.classId || currentClassId
        );
        if (groupConfig?.ai_grading_config?.grade_level) {
            configGradeLevel = groupConfig.ai_grading_config.grade_level;
        }
    }

    if (!configGradeLevel && (!submission?.complete || isCurrentSubmissionView)) {
        const classConfig = class_act.classes?.find(
            (c) => c.id === (class_act.classId || currentClassId)
        );
        const ai_grading_config =
            class_act.ai_grading_config ||
            classConfig?.ai_grading_config ||
            class_act.data?.ai_grading_config ||
            { creteria: {} };
        configGradeLevel =
            ai_grading_config?.creteria?.grade_level ||
            ai_grading_config?.criteria?.grade_level ||
            ai_grading_config?.grade_level;
    }

    let grade_level = aiGradeLevel;
    if (!grade_level || isUuid(grade_level)) {
        grade_level = configGradeLevel || grade_level;
    }
    if (!grade_level || isUuid(grade_level)) {
        return '';
    }

    return AI_GRADING_LEVEL_MAP[grade_level] || grade_level;
};

export const resolveOverallGradeForPrint = ({
    grade,
    isUngraded,
    isReturnedForSession,
    submission,
    getMarkStatus,
    getMarkStatusBingo,
}) => {
    if (isUngraded) {
        if (isReturnedForSession) {
            return 'Credit';
        }
        const current_submission = submission?.submissions || 0;
        if (submission?.assignmentType === 'bingo') {
            const mark = getMarkStatusBingo?.(isUngraded, current_submission, submission);
            return mark != null && mark !== '' ? String(mark) : '-';
        }
        const mark = getMarkStatus?.(isUngraded, current_submission, submission);
        return mark != null && mark !== '' ? String(mark) : '-';
    }

    if (grade != null && grade !== '') {
        return String(grade);
    }

    return '-';
};
